<div class="cbwf-dialog {{options.classes}}">
    <div class="remove"><span class="glyphicon glyphicon-remove"></span></div>
    <div class="header">{{title}}</div>
    <div class="body"></div>
</div>